var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmstemplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sms_templete",
    "data-name": "sms templete",
    transform: "translate(3165 -5635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    transform: "translate(-3165 5635)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652",
    transform: "translate(220 -223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "template",
    transform: "translate(-3375 5868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M69.722,73.494H3.772A3.772,3.772,0,0,1,0,69.722V3.772A3.772,3.772,0,0,1,3.772,0h65.95a3.772,3.772,0,0,1,3.773,3.773v65.95A3.772,3.772,0,0,1,69.722,73.494Zm0,0",
    transform: "translate(0 0.001)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M466.29,3.775v65.95a3.773,3.773,0,0,1-3.773,3.773h-3.888a3.773,3.773,0,0,0,3.773-3.773V3.775A3.773,3.773,0,0,0,458.629,0h3.888a3.772,3.772,0,0,1,3.773,3.771Zm0,0",
    transform: "translate(-392.795 -0.003)",
    fill: "#cecece",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M73.495,12.871H0v-9.1A3.772,3.772,0,0,1,3.773,0h65.95a3.772,3.772,0,0,1,3.773,3.773Zm0,0",
    transform: "translate(0 0)",
    fill: "#acacac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M466.29,3.775v9.1H462.4v-9.1A3.772,3.772,0,0,0,458.629,0h3.888a3.772,3.772,0,0,1,3.773,3.771Zm0,0",
    transform: "translate(-392.795 -0.003)",
    fill: "#9c9c9c",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M38.035,31.81a2.146,2.146,0,1,1-2.146-2.146A2.146,2.146,0,0,1,38.035,31.81Zm0,0",
    transform: "translate(-28.899 -25.406)",
    fill: "#ff5770"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M95.773,31.81a2.146,2.146,0,1,1-2.146-2.146,2.146,2.146,0,0,1,2.146,2.146Zm0,0",
    transform: "translate(-78.349 -25.406)",
    fill: "#ffd86e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M153.511,31.81a2.146,2.146,0,1,1-2.146-2.146A2.146,2.146,0,0,1,153.511,31.81Zm0,0",
    transform: "translate(-127.799 -25.406)",
    fill: "#80e0dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M42.012,31.811a2.144,2.144,0,0,1-3.625,1.552,2.144,2.144,0,0,0,1.43-3.7c.016,0,.034,0,.05,0a2.145,2.145,0,0,1,2.145,2.146Zm0,0",
    transform: "translate(-32.876 -25.406)",
    fill: "#ff435f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M99.743,31.811a2.145,2.145,0,0,1-3.626,1.552,2.144,2.144,0,0,0,1.432-3.7.473.473,0,0,1,.049,0,2.146,2.146,0,0,1,2.146,2.146Zm0,0",
    transform: "translate(-82.32 -25.406)",
    fill: "#ffb509"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M157.482,31.811a2.146,2.146,0,0,1-3.627,1.552,2.144,2.144,0,0,0,1.43-3.7c.016,0,.034,0,.05,0a2.146,2.146,0,0,1,2.146,2.146Zm0,0",
    transform: "translate(-131.77 -25.406)",
    fill: "#00a8b0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    transform: "translate(4.359 16.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M33.586,119.977H31.44a1.077,1.077,0,0,1,0-2.153h2.146a1.077,1.077,0,1,1,0,2.153Zm0,0",
    transform: "translate(-30.363 -117.824)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M33.586,158.614H31.44a1.077,1.077,0,1,1,0-2.153h2.146a1.077,1.077,0,1,1,0,2.153Zm0,0",
    transform: "translate(-30.363 -150.915)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M33.586,197.247H31.44a1.077,1.077,0,1,1,0-2.153h2.146a1.077,1.077,0,1,1,0,2.153Zm0,0",
    transform: "translate(-30.363 -184.002)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M33.586,235.883H31.44a1.077,1.077,0,0,1,0-2.153h2.146a1.077,1.077,0,0,1,0,2.153Zm0,0",
    transform: "translate(-30.363 -217.092)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M33.586,274.52H31.44a1.077,1.077,0,0,1,0-2.153h2.146a1.077,1.077,0,0,1,0,2.153Zm0,0",
    transform: "translate(-30.363 -250.183)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M33.586,313.157H31.44a1.077,1.077,0,0,1,0-2.153h2.146a1.077,1.077,0,0,1,0,2.153Zm0,0",
    transform: "translate(-30.363 -283.274)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M33.586,351.794H31.44a1.077,1.077,0,1,1,0-2.153h2.146a1.077,1.077,0,1,1,0,2.153Zm0,0",
    transform: "translate(-30.363 -316.365)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M33.586,390.43H31.44a1.077,1.077,0,1,1,0-2.153h2.146a1.077,1.077,0,1,1,0,2.153Zm0,0",
    transform: "translate(-30.363 -349.455)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M33.586,429.067H31.44a1.077,1.077,0,0,1,0-2.153h2.146a1.077,1.077,0,0,1,0,2.153Zm0,0",
    transform: "translate(-30.363 -382.546)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M33.586,467.7H31.44a1.077,1.077,0,1,1,0-2.153h2.146a1.077,1.077,0,1,1,0,2.153Zm0,0",
    transform: "translate(-30.363 -415.636)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M84.664,119.977H74.229a1.077,1.077,0,0,1,0-2.153H84.664a1.077,1.077,0,0,1,0,2.153Zm0,0",
    transform: "translate(-67.01 -117.824)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M84.664,274.52H74.229a1.077,1.077,0,0,1,0-2.153H84.664a1.077,1.077,0,0,1,0,2.153Zm0,0",
    transform: "translate(-67.01 -250.183)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M84.664,351.794H74.229a1.077,1.077,0,0,1,0-2.153H84.664a1.077,1.077,0,1,1,0,2.153Zm0,0",
    transform: "translate(-67.01 -316.365)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M80.076,158.614H74.229a1.077,1.077,0,1,1,0-2.153h5.847a1.077,1.077,0,1,1,0,2.153Zm0,0",
    transform: "translate(-67.01 -150.915)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M80.076,197.247H74.229a1.077,1.077,0,1,1,0-2.153h5.847a1.077,1.077,0,1,1,0,2.153Zm0,0",
    transform: "translate(-67.01 -184.002)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M80.076,467.7H74.229a1.077,1.077,0,1,1,0-2.153h5.847a1.077,1.077,0,1,1,0,2.153Zm0,0",
    transform: "translate(-67.01 -415.636)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M77.153,313.157H74.229a1.077,1.077,0,0,1,0-2.153h2.924a1.077,1.077,0,0,1,0,2.153Zm0,0",
    transform: "translate(-67.011 -283.274)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M82.843,235.883H74.229a1.077,1.077,0,0,1,0-2.153h8.614a1.077,1.077,0,0,1,0,2.153Zm0,0",
    transform: "translate(-67.01 -217.092)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M82.843,390.43H74.229a1.077,1.077,0,1,1,0-2.153h8.614a1.077,1.077,0,1,1,0,2.153Zm0,0",
    transform: "translate(-67.01 -349.455)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M82.843,429.067H74.229a1.077,1.077,0,0,1,0-2.153h8.614a1.077,1.077,0,0,1,0,2.153Zm0,0",
    transform: "translate(-67.01 -382.546)",
    fill: "#5a5a5a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651",
    transform: "translate(-3348.256 5893.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M45.155,225.425h6.863a9.155,9.155,0,0,1,9.155,9.155v11.077a1.934,1.934,0,0,1-1.934,1.934h0a1.933,1.933,0,0,1-1.7-1.011L56,243.736H45.155A9.155,9.155,0,0,1,36,234.58h0A9.155,9.155,0,0,1,45.155,225.425Z",
    transform: "translate(-36 -215.02)",
    fill: "#6cd0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M98.883,278.493v1.974a.493.493,0,0,1-.493.493h-7.9a.493.493,0,0,1-.494-.493v-1.974a.493.493,0,0,1,.494-.493h7.9A.493.493,0,0,1,98.883,278.493Zm-3.454,4.441H90.494a.494.494,0,0,0-.494.494V285.4a.493.493,0,0,0,.494.493h4.935a.493.493,0,0,0,.493-.493v-1.974A.494.494,0,0,0,95.428,282.935Z",
    transform: "translate(-84.67 -262.405)",
    fill: "#4191be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M246.118,129.156h0a9.155,9.155,0,0,1-9.155,9.155H226.121l-1.544,2.844a1.934,1.934,0,0,1-1.7,1.011h0a1.934,1.934,0,0,1-1.934-1.934V129.156A9.155,9.155,0,0,1,230.1,120h6.863A9.155,9.155,0,0,1,246.118,129.156Z",
    transform: "translate(-202.69 -120.001)",
    fill: "#ffe13c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M301.844,170.493v1.974a.493.493,0,0,1-.493.493H290.494a.494.494,0,0,1-.494-.493v-1.974a.494.494,0,0,1,.494-.493h10.857A.493.493,0,0,1,301.844,170.493Zm-.493,4.442h-8.39a.493.493,0,0,0-.493.493V177.4a.493.493,0,0,0,.493.493h8.39a.493.493,0,0,0,.493-.493v-1.974A.493.493,0,0,0,301.351,174.935Z",
    transform: "translate(-264.93 -165.065)",
    fill: "#ebb410"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmstemplete);
export default __webpack_public_path__ + "static/media/smstemplete.f3c489c14e96c450ffe8ffb5d28851fc.svg";
export { ForwardRef as ReactComponent };